import BaseStore from 'fluxible/addons/BaseStore';
import Actions from '../constants/Actions';

class ResultsStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.results = [];
  }

  handleLoadSuccess(param) {
    this.results = param;
    this.emitChange();
  }

  get() {
    return {
      results: this.results
    };
  }

  dehydrate() {
    return {
      results: this.results
    };
  }

  rehydrate(state) {
    this.results = state.results;
  }
}

ResultsStore.storeName = 'ResultsStore';
ResultsStore.handlers = {
  [Actions.LOAD_RESULTS_SUCCESS]: 'handleLoadSuccess'
};

export default ResultsStore;



// WEBPACK FOOTER //
// ./src/stores/ResultsStore.js